import { internalGet, post, put } from '.';

export const getNotifications = ({ filters }) => post('notifications', filters);

export const markNotificationAsRead = ({ notificationId }) =>
  put(`notifications/${notificationId}/read`);

export const markAllNotificationsAsRead = () => put('notifications/read');

// Every notification rendered as the bell shows it and as the inbox shows it.
// KOOB_ADMIN only (enforced server-side). `scope` decides whose urls,
// counterparty and margin are used; `values` picks the newest real booking
// (`demo`) or each `{{ field }}` printed as its own name (`names`).
export const getNotificationPreview = ({ scope, values }) =>
  internalGet(`/notifications/preview?scope=${scope}&values=${values}`);
